export default {
  // Tooltip content
  selectAll: "Select All (ctrl+a/command+a)",
  invertSelect: "Invert Selection",
  verticalArrange: "Vertical Arrangement (single column only)",
  backToCenter: "Back to Center",
  deleteNode: "Delete Node (delete)",
  previousStep: "Previous Step (ctrl+z/command+z)",
  nextStep: "Next Step (ctrl+f/command+f)",
  saveCanvas: "Save Canvas (alt+s/⌥+s)",
  fullScreen: "Full Screen ",
  exitFullScreen: "Exit Full Screen",

  // emit event text
  saveCanvasAction: "Save Canvas",
  fullScreenCanvas: "Full Screen Canvas",
  exitFullScreenAction: "Exit Full Screen",
  relevance: "Relevance",
};
